import React from 'react';

import { Container } from './styles';

const Workspace = ({ children }) => {
	return <Container>{children}</Container>;
};

export default Workspace;
